import { Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { CSSProperties } from "@material-ui/core/styles/withStyles";

export default makeStyles((theme: Theme) => {
  const detailsCell: CSSProperties = {
    padding: theme.spacing(0.5),
    display: "flex",
    alignItems: "center",
    height: "100%"
  };

  const employeeBtnGroup: CSSProperties = {
    padding: 0,
    height: theme.spacing(3),
    boxShadow: "none",
    alignItems: "stretch",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.common.white
    }
  };

  const sectionIcon: CSSProperties = {
    fontSize: "3rem !important"
  };

  return {
    breadcrumb: {
      margin: theme.spacing(2),

      [theme.breakpoints.up("sm")]: {
        marginLeft: theme.spacing(0),
        marginRight: theme.spacing(0)
      }
    },
    searchField: {
      maxWidth: 200,
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    },
    usersNotFoundCard: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: theme.spacing(2)
    },
    container: {
      padding: theme.spacing(2)
    },
    mobileSearch: {
      display: "flex",
      paddingBottom: theme.spacing(2)
    },
    mobileSearchField: {
      flex: 3
    },
    mobileSearchButton: {
      flex: 2,
      marginLeft: theme.spacing(2)
    },
    mobileListItem: {
      borderBottomWidth: 1,
      borderBottomColor: "black"
    },
    addButtonArea: {
      margin: theme.spacing(2),
      position: "fixed",
      bottom: 0,
      right: 0
    },
    userEditorWrapper: {
      marginTop: theme.spacing(2)
    },
    userEditorCard: {
      display: "flex",
      flexDirection: "column"
    },
    userEditor: {
      margin: theme.spacing(2)
    },
    addressCard: {
      marginTop: theme.spacing(2)
    },
    userEditorCardTitle: {
      padding: 0,
      margin: 0
    },
    saveButtonArea: {
      margin: theme.spacing(2),
      position: "fixed",
      bottom: 0,
      right: 0
    },
    saveButtonWrapper: {
      "&:hover": {
        backgroundColor: "transparent"
      }
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    },
    errorModalContainer: {
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      position: "absolute",
      width: "80%",
      backgroundColor: "#EFEFEF",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      borderRadius: theme.spacing(1)
    },
    errorModalIcon: {},
    errorModalButton: {
      backgroundColor: theme.palette.primary.main
    },
    userPageContainer: {
      ...theme.typography,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: theme.spacing(1)
    },
    tabsUpperContainer: {
      padding: theme.spacing(2),
      paddingTop: theme.spacing(1),
      backgroundColor: "white"
    },
    tabPanel: {
      paddingLeft: "0px !important",
      paddingRight: "0px !important"
    },
    pageHeaderButton: {
      width: "100%"
    },
    userDetailsSection: {
      marginBottom: theme.spacing(2)
    },
    userDetails: {
      marginBottom: theme.spacing(4)
    },
    userDetailsItem: {},
    detailsCell: {
      flex: 1,
      alignSelf: "stretch",
      height: theme.spacing(5)
    },
    detailsNameColumn: {
      ...detailsCell,
      color: theme.palette.grey[700]
    },
    detailsDataColumn: {
      ...detailsCell,
      wordBreak: "break-word",
      fontWeight: theme.typography.fontWeightBold
    },
    receiptsTableDesktop: {},
    receiptsTimelineDesktop: {
      maxHeight: 800,
      overflowY: "scroll",
      overflowX: "hidden"
    },
    receiptsTimelineMobile: {
      overflowY: "hidden",
      overflowX: "scroll"
    },
    timelineEvent: {
      fontSize: 12
    },
    addDiscountButton: {
      marginTop: theme.spacing(2)
    },
    sendNotificationButton: {
      marginTop: theme.spacing(2)
    },
    refundDialogContainer: {},
    refundItemHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    refundItemQuantityContainer: {
      display: "flex",
      alignItems: "center"
    },
    refundItemQuantity: {
      display: "flex",
      flex: 1
    },
    refundItemRefundQuantity: {
      display: "flex",
      alignItems: "center",
      flex: 2
    },
    refundQuantityLabel: {
      flex: 5,
      textAlign: "right",
      marginRight: theme.spacing(1)
    },
    refundQuantityValue: {
      flex: 1
    },
    refundPopover: {
      ...theme.typography,
      padding: theme.spacing(3)
    },
    refundConfirmButtons: {},
    refundSaveButton: {
      marginRight: theme.spacing(2)
    },
    refundCancelButton: {},
    drawerMenuItem: {
      paddingLeft: 0
    },
    drawerAction: {
      display: "flex",
      paddingRight: theme.spacing(2),
      alignItems: "center"
    },
    drawerMenuCategory: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      backgroundColor: theme.palette.grey[50],
      display: "flex",
      alignItems: "center",
      "& .MuiTypography-root": {
        textIndent: theme.spacing(2)
      }
    },
    employeeBtnSelected: {
      ...employeeBtnGroup,
      fontWeight: theme.typography.fontWeightBold as number,
      borderColor: theme.palette.primary.dark,
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      "&:first-child": {
        borderRightWidth: "1px",
        borderRightColor: theme.palette.primary.dark
      }
    },
    employeeBtn: {
      ...employeeBtnGroup
    },
    fullHeight: {
      minHeight: "100%"
    },
    sectionIconSuccess: {
      ...sectionIcon,
      color: theme.palette.success.dark
    },
    sectionIconPrimary: {
      ...sectionIcon,
      color: theme.palette.primary.dark
    },
    sectionIconWarning: {
      ...sectionIcon,
      color: theme.palette.warning.dark
    },
    sectionIconError: {
      ...sectionIcon,
      color: theme.palette.error.dark
    },
    error: {
      color: theme.palette.error.dark
    },
    success: {
      color: theme.palette.success.dark
    },
    storesSelector: {
      width: 95,
      paddingBottom: "1rem",
      [theme.breakpoints.up("sm")]: {
        width: 200
      }
    },
    spinnerContainer: {
      position: "absolute",
      backgroundColor: "rgba(255,255,255,0.8)",
      zIndex: 100,
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    flex: {
      display: "flex"
    },
    center: {
      marginRight: "auto",
      marginLeft: "auto"
    },
    field: {
      display: "flex",
      justifyContent: "center",
      marginBottom: theme.spacing(2)
    },
    historyPanel: {
      padding: "10px 0px 10px 20px",
      width: "100%"
    }
  };
});
